import styled from 'styled-components';
import colors from 'constants/colors';

export const HotelInfoAndPoliciesContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  background-color: ${colors.black1};
`;

export const Content = styled.div`
  width: 100%;
`;

export const ItemContainer = styled.div`
  width: calc(50% - 8px);
  color: ${colors.white};
  border: 1px solid ${colors.darkGrey};
  background-color: transparent;
  padding: 16px;

  .title{
    display: flex;
    justify-content: flex-start;
    align-items: center;
    font-size: 14px;
    font-weight: 600;
    color: ${colors.white};
    margin-bottom: 24px;

    .slider {
      margin-left: 8px;
    }
  }

  .values {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    column-gap: 20px;

    .label {
      font-size: 12px;
      font-weight: 300;
      color: ${colors.silver};
      letter-spacing: 1px;
      margin-bottom: 5px;
      white-space: nowrap;
    }

    .checkInTimeContainer,
    .checkOutTimeContainer {

    }
  }
`;
